// EliteMeat Farm - Product Catalog
// Categories: Beef Meat (48), Elite Beef Steaks (11), Lamb Meat (16), Homemade Products (5), Smoked (6)
// Total: 86 products

export const products = [
  // ==================== BEEF MEAT CATEGORY (49 products) ====================
  {
    id: 1,
    name: "Fillet Red Casserole Cubes",
    category: "Beef Meat",
    description: "Premium fillet cubes for casseroles",
    image: "https://i.pinimg.com/736x/c3/46/1c/c3461c48eb5789ff2f17d4ed90be3949.jpg?w=500",
    images: ["https://i.pinimg.com/736x/c3/46/1c/c3461c48eb5789ff2f17d4ed90be3949.jpg?w=800"],
    fullDescription: "Premium fillet cubes cut from the finest tenderloin. Perfect for casseroles and elegant stews.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      storage: "Keep refrigerated at 0-4°C",
      shelfLife: "3-5 days refrigerated"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg", "2.5kg", "3kg", "3.5kg", "4kg", "4.5kg", "5kg"],
    pricing: { "500g": 280, "1kg": 560, "1.5kg": 840, "2kg": 1120, "2.5kg": 1400, "3kg": 1680, "3.5kg": 1960, "4kg": 2240, "4.5kg": 2520, "5kg": 2800 },
    cutTypes: ["Cubed"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 2,
    name: "Fillet Cubes",
    category: "Beef Meat",
    description: "Premium fillet cubes for stir-fry and stews",
    image: "https://i.pinimg.com/1200x/ed/6a/ec/ed6aec642233ba99e15ad3492e989764.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/ed/6a/ec/ed6aec642233ba99e15ad3492e989764.jpg?w=800"],
    fullDescription: "Premium fillet cubes cut from the finest tenderloin. Perfect for quick stir-fries.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      storage: "Keep refrigerated at 0-4°C",
      shelfLife: "3-5 days refrigerated"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg", "2.5kg", "3kg", "3.5kg", "4kg", "4.5kg", "5kg"],
    pricing: { "500g": 370, "1kg": 740, "1.5kg": 1110, "2kg": 1480, "2.5kg": 1850, "3kg": 2220, "3.5kg": 2590, "4kg": 2960, "4.5kg": 3330, "5kg": 3700 },
    cutTypes: ["Cubed"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 3,
    name: "Stewing Cubes",
    category: "Beef Meat",
    description: "Classic beef cubes for traditional stews",
    image: "https://i.pinimg.com/1200x/e7/7b/ae/e77baeac0fea348716bb0e73216e7f89.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/e7/7b/ae/e77baeac0fea348716bb0e73216e7f89.jpg?w=800"],
    fullDescription: "Premium beef stewing cubes with perfect fat-to-lean ratio.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      bestUse: "Stewing, braising",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg", "2.5kg", "3kg", "3.5kg", "4kg", "4.5kg", "5kg"],
    pricing: { "500g": 270, "1kg": 540, "1.5kg": 810, "2kg": 1080, "2.5kg": 1350, "3kg": 1620, "3.5kg": 1890, "4kg": 2160, "4.5kg": 2430, "5kg": 2700 },
    cutTypes: ["Cubed"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 4,
    name: "Stewing Cubes Fat",
    category: "Beef Meat",
    description: "Beef cubes with extra fat for rich flavor",
    image: "https://i.pinimg.com/1200x/d9/9b/9b/d99b9b8b30364969abeeb60a7ba7c243.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/d9/9b/9b/d99b9b8b30364969abeeb60a7ba7c243.jpg?w=800"],
    fullDescription: "Beef stewing cubes with extra fat for richer, more flavorful stews.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      fatContent: "Higher fat content",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg", "2.5kg", "3kg", "3.5kg", "4kg", "4.5kg", "5kg"],
    pricing: { "500g": 245, "1kg": 490, "1.5kg": 735, "2kg": 980, "2.5kg": 1225, "3kg": 1470, "3.5kg": 1715, "4kg": 1960, "4.5kg": 2205, "5kg": 2450 },
    cutTypes: ["Cubed"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 5,
    name: "Shin Beef",
    category: "Beef Meat",
    description: "Beef shin for slow cooking",
    image: "https://i.pinimg.com/originals/06/8b/26/068b26a00883b930edbdaff53dc53f9f.jpg?w=500",
    images: ["https://i.pinimg.com/originals/06/8b/26/068b26a00883b930edbdaff53dc53f9f.jpg?w=800"],
    fullDescription: "Beef shin perfect for slow-cooked dishes and rich broths.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      bestUse: "Slow cooking, stews",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg", "2.5kg", "3kg"],
    pricing: { "500g": 280, "1kg": 560, "1.5kg": 810, "2kg": 1080, "2.5kg": 1350, "3kg": 1620 },
    cutTypes: ["Bone-In", "Boneless"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 6,
    name: "Osso Bucco",
    category: "Beef Meat",
    description: "Cross-cut beef shank for Italian classics",
    image: "https://i.pinimg.com/736x/21/bf/70/21bf706c4077163af4450f974d0f9d54.jpg?w=500",
    images: ["https://i.pinimg.com/736x/21/bf/70/21bf706c4077163af4450f974d0f9d54.jpg?w=800"],
    fullDescription: "Cross-cut beef shank with marrow, perfect for osso bucco.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      bestUse: "Braising, osso bucco",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 270, "1kg": 540, "1.5kg": 810, "2kg": 1080 },
    cutTypes: ["Cross-Cut"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 7,
    name: "Osso Bucco Piece",
    category: "Beef Meat",
    description: "Individual osso bucco pieces",
    image: "https://i.pinimg.com/736x/e7/5b/a0/e75ba04482534b25a4d1738e9fa3c04d.jpg?w=500",
    images: ["https://i.pinimg.com/736x/e7/5b/a0/e75ba04482534b25a4d1738e9fa3c04d.jpg?w=800"],
    fullDescription: "Individual osso bucco pieces, perfect portion size for single servings.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      bestUse: "Individual portions",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["Per Piece"],
    pricing: { "Per Piece": 210 },
    cutTypes: ["Individual Piece"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 8,
    name: "Piccata",
    category: "Beef Meat",
    description: "Thin beef slices for piccata",
    image: "https://i.pinimg.com/1200x/ae/14/8b/ae148b505f554361bd79a1cc61efa83b.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/ae/14/8b/ae148b505f554361bd79a1cc61efa83b.jpg?w=800"],
    fullDescription: "Thinly sliced beef perfect for piccata and quick pan-frying.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      bestUse: "Piccata, pan-frying",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 275, "1kg": 550, "1.5kg": 825, "2kg": 1100 },
    cutTypes: ["Thin Slices"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 9,
    name: "Escalope",
    category: "Beef Meat",
    description: "Flattened beef cutlets",
    image: "https://i.pinimg.com/736x/a4/8b/08/a48b08fa50cb2280f32528355043da4d.jpg?w=500",
    images: ["https://i.pinimg.com/736x/a4/8b/08/a48b08fa50cb2280f32528355043da4d.jpg?w=800"],
    fullDescription: "Flattened beef cutlets, perfect for schnitzel or escalope dishes.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      bestUse: "Schnitzel, escalope",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 285, "1kg": 570, "1.5kg": 855, "2kg": 1140 },
    cutTypes: ["Flattened"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 10,
    name: "Beef Shabu Shabu",
    category: "Beef Meat",
    description: "Paper-thin beef slices for hot pot",
    image: "https://i.pinimg.com/1200x/0e/7c/55/0e7c557e364dfc9dd288d36c08fd5169.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/0e/7c/55/0e7c557e364dfc9dd288d36c08fd5169.jpg?w=800"],
    fullDescription: "Paper-thin beef slices perfect for Japanese shabu shabu hot pot.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      bestUse: "Shabu shabu, hot pot",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg"],
    pricing: { "500g": 275, "1kg": 550, "1.5kg": 825 },
    cutTypes: ["Paper-Thin Slices"],
    packagingOptions: ["Vacuum Sealed"]
  },
  {
    id: 11,
    name: "Shawerma",
    category: "Beef Meat",
    description: "Sliced beef for shawerma",
    image: "https://i.pinimg.com/1200x/35/4f/6c/354f6c5fbea809cd705ae5483693d85c.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/35/4f/6c/354f6c5fbea809cd705ae5483693d85c.jpg?w=800"],
    fullDescription: "Fresh sliced beef prepared for shawerma.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      bestUse: "Shawerma",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 275, "1kg": 550, "1.5kg": 825, "2kg": 1100 },
    cutTypes: ["Sliced"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 12,
    name: "Marinated Shawerma",
    category: "Beef Meat",
    description: "Pre-marinated beef shawerma",
    image: "https://i.pinimg.com/1200x/7b/71/88/7b7188160df1bff0e372e662c6f7c306.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/7b/71/88/7b7188160df1bff0e372e662c6f7c306.jpg?w=800"],
    fullDescription: "Pre-marinated beef slices with traditional shawerma spices.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      marinated: "Traditional spices",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 285, "1kg": 570, "1.5kg": 855, "2kg": 1140 },
    cutTypes: ["Sliced and Marinated"],
    packagingOptions: ["Fresh Pack"]
  },
  {
    id: 13,
    name: "Beef Stroganoff",
    category: "Beef Meat",
    description: "Pre-cut beef strips for stroganoff",
    image: "https://i.pinimg.com/1200x/d3/ad/0a/d3ad0a6072de4a94479c27064bd1774d.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/d3/ad/0a/d3ad0a6072de4a94479c27064bd1774d.jpg?w=800"],
    fullDescription: "Tender beef strips cut perfectly for stroganoff dishes.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      preparation: "Pre-sliced strips",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg"],
    pricing: { "500g": 270, "1kg": 540, "1.5kg": 810 },
    cutTypes: ["Strips"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 14,
    name: "Ground Beef Red",
    category: "Beef Meat",
    description: "Lean ground beef",
    image: "https://i.pinimg.com/736x/88/88/93/8888930bd51433598276e1de7ea78076.jpg?w=500",
    images: ["https://i.pinimg.com/736x/88/88/93/8888930bd51433598276e1de7ea78076.jpg?w=800"],
    fullDescription: "Premium lean ground beef, perfect for healthy cooking.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Ground fresh daily",
      fatContent: "Low fat",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg", "2.5kg", "3kg"],
    pricing: { "500g": 270, "1kg": 540, "1.5kg": 810, "2kg": 1080, "2.5kg": 1350, "3kg": 1620 },
    cutTypes: ["Ground"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 15,
    name: "Ground Beef Low Fat",
    category: "Beef Meat",
    description: "Extra lean ground beef",
    image: "https://i.pinimg.com/1200x/10/5a/44/105a44ed0d7ec9b9fd2422acb59f7269.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/10/5a/44/105a44ed0d7ec9b9fd2422acb59f7269.jpg?w=800"],
    fullDescription: "Extra lean ground beef for health-conscious cooking.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Ground fresh daily",
      fatContent: "Extra low fat",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg", "2.5kg", "3kg"],
    pricing: { "500g": 265, "1kg": 530, "1.5kg": 795, "2kg": 1060, "2.5kg": 1325, "3kg": 1590 },
    cutTypes: ["Ground"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 16,
    name: "Ground Beef Medium",
    category: "Beef Meat",
    description: "Ground beef with balanced fat",
    image: "https://i.pinimg.com/1200x/85/cc/4d/85cc4d30441a5dc245d53016b90e81f0.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/85/cc/4d/85cc4d30441a5dc245d53016b90e81f0.jpg?w=800"],
    fullDescription: "Ground beef with balanced fat content for juicy results.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Ground fresh daily",
      fatContent: "Medium",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg", "2.5kg", "3kg"],
    pricing: { "500g": 260, "1kg": 520, "1.5kg": 780, "2kg": 1040, "2.5kg": 1300, "3kg": 1560 },
    cutTypes: ["Ground"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 17,
    name: "Liver",
    category: "Beef Meat",
    description: "Fresh beef liver",
    image: "https://i.pinimg.com/1200x/98/62/b6/9862b620c65824123343a131082471e5.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/98/62/b6/9862b620c65824123343a131082471e5.jpg?w=800"],
    fullDescription: "Fresh beef liver, rich in iron and nutrients.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      bestUse: "Frying, grilling",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 330, "1kg": 660, "1.5kg": 990, "2kg": 1320 },
    cutTypes: ["Whole", "Sliced"],
    packagingOptions: ["Fresh Pack"]
  },
  {
    id: 18,
    name: "Heart",
    category: "Beef Meat",
    description: "Fresh beef heart",
    image: "https://i.pinimg.com/1200x/c6/ec/2f/c6ec2f674cdadef474b9ca2974dfaf64.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/c6/ec/2f/c6ec2f674cdadef474b9ca2974dfaf64.jpg?w=800"],
    fullDescription: "Fresh beef heart - lean and flavorful.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      bestUse: "Grilling, slow cooking",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 220, "1kg": 440, "1.5kg": 660, "2kg": 880 },
    cutTypes: ["Whole", "Sliced"],
    packagingOptions: ["Fresh Pack"]
  },
  {
    id: 19,
    name: "Kidney",
    category: "Beef Meat",
    description: "Fresh beef kidney",
    image: "https://i.pinimg.com/736x/72/9f/c9/729fc9b3661363e86a6898b420695c97.jpg?w=500",
    images: ["https://i.pinimg.com/736x/72/9f/c9/729fc9b3661363e86a6898b420695c97.jpg?w=800"],
    fullDescription: "Fresh beef kidney for traditional dishes.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      bestUse: "Stews, pies",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 220, "1kg": 440, "1.5kg": 660, "2kg": 880 },
    cutTypes: ["Whole", "Halved"],
    packagingOptions: ["Fresh Pack"]
  },
  {
    id: 20,
    name: "Beef Oxtail",
    category: "Beef Meat",
    description: "Fresh oxtail for rich stews",
    image: "https://i.pinimg.com/1200x/2f/52/a5/2f52a5ceccbfda602daa322d0ef6910c.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/2f/52/a5/2f52a5ceccbfda602daa322d0ef6910c.jpg?w=800"],
    fullDescription: "Fresh oxtail perfect for rich, gelatinous stews and soups.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      bestUse: "Stews, soups",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g"],
    pricing: { "per piece": 810},
    cutTypes: ["Pieces"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 21,
    name: "Beef Marrow Bone",
    category: "Beef Meat",
    description: "Marrow bones for cooking",
    image: "https://i.pinimg.com/1200x/05/b7/90/05b79033b2aa7b3ccd164a753dbff578.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/05/b7/90/05b79033b2aa7b3ccd164a753dbff578.jpg?w=800"],
    fullDescription: "Beef marrow bones for rich broths and roasting.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      bestUse: "Broths, roasting",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["Per Piece", "500g", "1kg"],
    pricing: { "Per Piece": 45, "500g": 85, "1kg": 170 },
    cutTypes: ["Cross-Cut", "Split"],
    packagingOptions: ["Fresh Pack"]
  },
  {
    id: 23,
    name: "Trotter Pieces",
    category: "Beef Meat",
    description: "Beef trotter pieces",
    image: "https://meathouseshop.com/images/thumbs/0002538_-.jpeg?w=500",
    images: ["https://meathouseshop.com/images/thumbs/0002538_-.jpeg?w=800"],
    fullDescription: "Beef trotter pieces for traditional soups and stews.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      bestUse: "Soups, kawarea",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["1kg", "2kg", "3kg", "4kg", "5kg"],
    pricing: { "1kg": 385, "2kg": 755, "3kg": 1135, "4kg": 1515, "5kg": 1890 },
    cutTypes: ["Pieces"],
    packagingOptions: ["Fresh Pack"]
  },
  {
    id: 24,
    name: "Beef Brain",
    category: "Beef Meat",
    description: "Fresh beef brain",
    image: "https://tasmanianprimemeat.com.au/wp-content/uploads/2020/12/beef-brain.jpg?w=500",
    images: ["https://tasmanianprimemeat.com.au/wp-content/uploads/2020/12/beef-brain.jpg?w=800"],
    fullDescription: "Fresh beef brain - a traditional delicacy.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      bestUse: "Frying",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["Per Piece" ],
    pricing: { "Per Piece": 320  },
    cutTypes: ["Whole"],
    packagingOptions: ["Fresh Pack"]
  },
  {
    id: 25,
    name: "Beef Spleen",
    category: "Beef Meat",
    description: "Fresh beef spleen",
    image: "https://longbottomfarm.com/wp-content/uploads/2023/08/Beef-Spleen.jpg?w=500",
    images: ["https://longbottomfarm.com/wp-content/uploads/2023/08/Beef-Spleen.jpg?w=800"],
    fullDescription: "Fresh beef spleen for traditional recipes.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      bestUse: "Traditional dishes",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["Per Piece"],
    pricing: { "Per Piece": 300 },
    cutTypes: ["Whole"],
    packagingOptions: ["Fresh Pack"]
  },
  {
    id: 26,
    name: "Testicles",
    category: "Beef Meat",
    description: "Traditional delicacy",
    image: "https://i.pinimg.com/originals/28/98/00/28980036c85ae51f3d644e282a6647f9.jpg?w=500",
    images: ["https://i.pinimg.com/originals/28/98/00/28980036c85ae51f3d644e282a6647f9.jpg?w=800"],
    fullDescription: "Fresh beef testicles - a traditional delicacy.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      bestUse: "Frying, grilling",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 150, "1kg": 300, "1.5kg": 450, "2kg": 600 },
    cutTypes: ["Cleaned"],
    packagingOptions: ["Fresh Pack"]
  },
  {
    id: 27,
    name: "Beef Burger",
    category: "Beef Meat",
    description: "Premium beef burger patties",
    image: "https://i.pinimg.com/736x/b7/2e/01/b72e01d6aa693652fcd22f5fec7d4bfe.jpg?w=500",
    images: ["https://i.pinimg.com/736x/b7/2e/01/b72e01d6aa693652fcd22f5fec7d4bfe.jpg?w=800"],
    fullDescription: "Premium beef burger patties, freshly made.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Made fresh daily",
      weight: "150g per patty",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 250, "1kg": 500, "1.5kg": 750, "2kg": 1000 },
    cutTypes: ["Classic Patty"],
    packagingOptions: ["Fresh Pack", "Freezer Pack"]
  },
  {
    id: 28,
    name: "Smoked Beef Burger",
    category: "Beef Meat",
    description: "Smoked beef burger patties",
    image: "https://i.pinimg.com/736x/6b/4a/31/6b4a31b5caa4549b8fe36370a642646f.jpg?w=500",
    images: ["https://i.pinimg.com/736x/6b/4a/31/6b4a31b5caa4549b8fe36370a642646f.jpg?w=800"],
    fullDescription: "Smoked beef burger patties with rich smoky flavor.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Made fresh daily",
      flavor: "Smoked",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 275, "1kg": 550, "1.5kg": 825, "2kg": 1100 },
    cutTypes: ["Smoked Patty"],
    packagingOptions: ["Fresh Pack", "Freezer Pack"]
  },
  {
    id: 29,
    name: "Cheese Burger",
    category: "Beef Meat",
    description: "Beef burger with cheese filling",
    image: "https://i.pinimg.com/736x/63/b4/13/63b413b38b2da18d0fb16e420b79647d.jpg?w=500",
    images: ["https://i.pinimg.com/736x/63/b4/13/63b413b38b2da18d0fb16e420b79647d.jpg?w=800"],
    fullDescription: "Beef burger patties stuffed with melting cheese.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Made fresh daily",
      filling: "Cheese",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 265, "1kg": 530, "1.5kg": 795, "2kg": 1060 },
    cutTypes: ["Stuffed Patty"],
    packagingOptions: ["Fresh Pack", "Freezer Pack"]
  },
  {
    id: 30,
    name: "Sausage",
    category: "Beef Meat",
    description: "Fresh beef sausages",
    image: "https://i.pinimg.com/736x/32/e2/03/32e2033cccc27a109574c16464556611.jpg?w=500",
    images: ["https://i.pinimg.com/736x/32/e2/03/32e2033cccc27a109574c16464556611.jpg?w=800"],
    fullDescription: "Fresh beef sausages with natural casings.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Made fresh daily",
      casings: "Natural",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 260, "1kg": 520, "1.5kg": 780, "2kg": 1040 },
    cutTypes: ["Links"],
    packagingOptions: ["Fresh Pack", "Vacuum Sealed"]
  },
  {
    id: 31,
    name: "Hot Sausage",
    category: "Beef Meat",
    description: "Spicy beef sausages",
    image: "https://i.pinimg.com/736x/c8/0e/d5/c80ed51055fe347dbfceeb496b08c5d5.jpg?w=500",
    images: ["https://i.pinimg.com/736x/c8/0e/d5/c80ed51055fe347dbfceeb496b08c5d5.jpg?w=800"],
    fullDescription: "Spicy beef sausages with hot peppers.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Made fresh daily",
      spiceLevel: "Hot",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 260, "1kg": 520, "1.5kg": 780, "2kg": 1040 },
    cutTypes: ["Links"],
    packagingOptions: ["Fresh Pack", "Vacuum Sealed"]
  },
  {
    id: 32,
    name: "Smoked Sausage",
    category: "Beef Meat",
    description: "Smoked beef sausages",
    image: "https://i.pinimg.com/1200x/eb/ce/bf/ebcebf26b7381f0e34ecf000f07f6ad8.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/eb/ce/bf/ebcebf26b7381f0e34ecf000f07f6ad8.jpg?w=800"],
    fullDescription: "Smoked beef sausages with rich smoky flavor.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Made fresh daily",
      preparation: "Smoked",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 275, "1kg": 550, "1.5kg": 825, "2kg": 1100 },
    cutTypes: ["Links"],
    packagingOptions: ["Vacuum Sealed"]
  },
  {
    id: 33,
    name: "Meat Balls",
    category: "Beef Meat",
    description: "Homemade beef meatballs",
    image: "https://i.pinimg.com/736x/b5/95/60/b59560eca34b0ec437f56d310910f838.jpg?w=500",
    images: ["https://i.pinimg.com/736x/b5/95/60/b59560eca34b0ec437f56d310910f838.jpg?w=800"],
    fullDescription: "Homemade-style beef meatballs with herbs and spices.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Made fresh daily",
      ingredients: "Beef, herbs, spices",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 250, "1kg": 500, "1.5kg": 750, "2kg": 1000 },
    cutTypes: ["Traditional"],
    packagingOptions: ["Fresh Pack", "Freezer Pack"]
  },
  {
    id: 34,
    name: "Grill Kofta",
    category: "Beef Meat",
    description: "Traditional grill kofta",
    image: "https://i.pinimg.com/736x/0d/a0/aa/0da0aae40451e843187c95b9ebc61f97.jpg?=500",
    images: ["https://i.pinimg.com/736x/0d/a0/aa/0da0aae40451e843187c95b9ebc61f97.jpg?w=800"],
    fullDescription: "Traditional Egyptian grill kofta with aromatic spices.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Made fresh daily",
      spiced: "Traditional kofta blend",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 250, "1kg": 500, "1.5kg": 750, "2kg": 1000 },
    cutTypes: ["On Skewers", "Loose"],
    packagingOptions: ["Fresh Pack"]
  },
  {
    id: 35,
    name: "Rice Kofta",
    category: "Beef Meat",
    description: "Kofta with rice filling",
    image: "https://i.pinimg.com/736x/2c/b8/dd/2cb8dd1ca0707c9d117142f5026dabd8.jpg?w=500",
    images: ["https://i.pinimg.com/736x/2c/b8/dd/2cb8dd1ca0707c9d117142f5026dabd8.jpg?w=800"],
    fullDescription: "Beef kofta with rice - perfect for stuffing and baking.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Made fresh daily",
      filling: "Rice",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 165, "1kg": 330, "1.5kg": 495, "2kg": 660 },
    cutTypes: ["Mixed"],
    packagingOptions: ["Fresh Pack"]
  },
  {
    id: 36,
    name: "Hawawshi Meat",
    category: "Beef Meat",
    description: "Seasoned meat for hawawshi",
    image: "https://cdn.shopify.com/s/files/1/1171/9060/products/lamb_ground_1_2048x2048.jpg?v=1531797922?w=500",
    images: ["https://cdn.shopify.com/s/files/1/1171/9060/products/lamb_ground_1_2048x2048.jpg?v=1531797922?w=800"],
    fullDescription: "Pre-seasoned beef mixture perfect for Egyptian hawawshi.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Made fresh daily",
      seasoned: "Traditional hawawshi spices",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 185, "1kg": 370, "1.5kg": 555, "2kg": 740 },
    cutTypes: ["Ground and Seasoned"],
    packagingOptions: ["Fresh Pack"]
  },
  {
    id: 37,
    name: "Hawawshi Bread (2 pieces)",
    category: "Beef Meat",
    description: "Ready hawawshi with bread",
    image: "https://i.pinimg.com/1200x/b5/cf/e7/b5cfe77a816555330c9e4f9c63f69560.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/b5/cf/e7/b5cfe77a816555330c9e4f9c63f69560.jpg?w=800"],
    fullDescription: "Ready-to-cook hawawshi stuffed in traditional bread - 2 pieces.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Made fresh daily",
      contents: "2 pieces",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["2 Pieces", "4 Pieces", "6 Pieces"],
    pricing: { "2 Pieces": 105, "4 Pieces": 210, "6 Pieces": 315 },
    cutTypes: ["Stuffed"],
    packagingOptions: ["Fresh Pack"]
  },
  {
    id: 38,
    name: "Hawawshi Cheese",
    category: "Beef Meat",
    description: "Hawawshi with cheese",
    image: "https://images.deliveryhero.io/image/talabat/MenuItems/0DE9BD69073B520093A838F547A032C2?w=500",
    images: ["https://images.deliveryhero.io/image/talabat/MenuItems/0DE9BD69073B520093A838F547A032C2?w=800"],
    fullDescription: "Hawawshi with melting cheese - a modern twist on the classic.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Made fresh daily",
      filling: "Beef and cheese",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["2 Pieces", "4 Pieces", "6 Pieces"],
    pricing: { "2 Pieces": 120, "4 Pieces": 240, "6 Pieces": 360 },
    cutTypes: ["Stuffed with Cheese"],
    packagingOptions: ["Fresh Pack"]
  },
  {
    id: 39,
    name: "Beef Schnitzel Bread Crumbs",
    category: "Beef Meat",
    description: "Breaded beef schnitzel",
    image: "https://i.pinimg.com/1200x/58/25/22/58252284cdc3daacab9d3cbe32ba4154.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/58/25/22/58252284cdc3daacab9d3cbe32ba4154.jpg?w=800"],
    fullDescription: "Premium beef schnitzel coated with bread crumbs, ready to fry.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Made fresh daily",
      coating: "Bread crumbs",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 280, "1kg": 560, "1.5kg": 840, "2kg": 1120 },
    cutTypes: ["Breaded"],
    packagingOptions: ["Fresh Pack", "Freezer Pack"]
  },
  {
    id: 40,
    name: "Eye Round Roast",
    category: "Beef Meat",
    description: "Lean eye round for roasting",
    image: "https://i.pinimg.com/1200x/a2/28/ff/a228ff4a12e1128d4b644d5a9bfc880e.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/a2/28/ff/a228ff4a12e1128d4b644d5a9bfc880e.jpg?w=800"],
    fullDescription: "Very lean eye of round - perfect for roasting.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      bestUse: "Roasting, deli slicing",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["per piece"],
    pricing: { "per piece": 1500 },
    cutTypes: ["Whole"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 41,
    name: "Bottom Round Roast",
    category: "Beef Meat",
    description: "Economical cut for roasting",
    image: "https://i.pinimg.com/1200x/1a/9e/eb/1a9eebb57e2c789a27e017fb0ea97acb.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/1a/9e/eb/1a9eebb57e2c789a27e017fb0ea97acb.jpg?w=800"],
    fullDescription: "Economical bottom round roast - great for pot roast.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      bestUse: "Pot roast, braising",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["1kg", "1.5kg", "2kg", "2.5kg", "3kg"],
    pricing: { "1kg": 550, "1.5kg": 825, "2kg": 1100, "2.5kg": 1375, "3kg": 1650 },
    cutTypes: ["Whole"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 42,
    name: "Picanha Joint",
    category: "Beef Meat",
    description: "Brazilian-style picanha roast",
    image: "https://i.pinimg.com/1200x/86/96/03/8696038c4eba34cccfd8abd47e219b59.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/86/96/03/8696038c4eba34cccfd8abd47e219b59.jpg?w=800"],
    fullDescription: "Brazilian-style picanha with signature fat cap for roasting.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      fatCap: "Yes",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["per piece"],
    pricing: { "per piece": 800 },
    cutTypes: ["Whole Joint"],
    packagingOptions: ["Vacuum Sealed"]
  },
  {
    id: 43,
    name: "Red Fillet Roast",
    category: "Beef Meat",
    description: "Premium fillet roast",
    image: "https://i.pinimg.com/736x/c6/f6/53/c6f653d22378441eba0aaf5d18cd07a6.jpg?w=500",
    images: ["https://i.pinimg.com/736x/c6/f6/53/c6f653d22378441eba0aaf5d18cd07a6.jpg?w=800"],
    fullDescription: "Premium whole fillet roast - the most tender cut.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      aging: "14-day aged",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["per piece"],
    pricing: { "per piece": 1350 },
    cutTypes: ["Whole"],
    packagingOptions: ["Vacuum Sealed"]
  },
  {
    id: 44,
    name: "Full Fillet Roast with Minced Meat",
    category: "Beef Meat",
    description: "Fillet roast stuffed with minced meat",
    image: "https://i.pinimg.com/1200x/7c/12/34/7c12346df96dc1270000d945071ed998.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/7c/12/34/7c12346df96dc1270000d945071ed998.jpg?w=800"],
    fullDescription: "Premium fillet roast stuffed with seasoned minced meat.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Made fresh daily",
      stuffed: "Minced meat",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["per piece"],
    pricing: { "per piece": 1850},
    cutTypes: ["Stuffed"],
    packagingOptions: ["Vacuum Sealed"]
  },
  {
    id: 45,
    name: "Beef Shank Roast",
    category: "Beef Meat",
    description: "Whole beef shank for roasting",
    image: "https://i.pinimg.com/736x/75/15/b9/7515b94a60c2ec6ab4ff5f3f97bdf717.jpg?w=500",
    images: ["https://i.pinimg.com/736x/75/15/b9/7515b94a60c2ec6ab4ff5f3f97bdf717.jpg?w=800"],
    fullDescription: "Whole beef shank - perfect for slow roasting.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      bestUse: "Slow roasting",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["per piece"],
    pricing: { "per piece": 1550 },
    cutTypes: ["Whole"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 46,
    name: "Short Ribs Whole",
    category: "Beef Meat",
    description: "Whole short ribs rack",
    image: "https://primepoultryexporters.com/wp-content/uploads/2021/05/Beef-Short-Ribs-Frozen-farm-exporters2-600x600.jpg?w=500",
    images: ["https://primepoultryexporters.com/wp-content/uploads/2021/05/Beef-Short-Ribs-Frozen-farm-exporters2-600x600.jpg?w=800"],
    fullDescription: "Whole short ribs rack - perfect for BBQ and braising.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      bestUse: "BBQ, braising",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["per piece"],
    pricing: { "per piece": 1800 },
    cutTypes: ["Whole Rack"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 47,
    name: "Short Ribs Pieces",
    category: "Beef Meat",
    description: "Cut short ribs pieces",
    image: "https://i.pinimg.com/1200x/bf/34/a7/bf34a710d1b0455c20929af7662a41af.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/bf/34/a7/bf34a710d1b0455c20929af7662a41af.jpg?w=800"],
    fullDescription: "Pre-cut short ribs pieces - ready for cooking.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      bestUse: "Grilling, braising",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["per piece"],
    pricing: { "per piece": 185 },
    cutTypes: ["Cut Pieces"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 48,
    name: "Brisket",
    category: "Beef Meat",
    description: "Whole beef brisket",
    image: "https://i.pinimg.com/1200x/3e/e5/1e/3ee51e3a1cb32d8775adf475e4ad0200.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/3e/e5/1e/3ee51e3a1cb32d8775adf475e4ad0200.jpg?w=800"],
    fullDescription: "Whole beef brisket - perfect for smoking and slow cooking.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      bestUse: "Smoking, slow cooking",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["1kg", "2kg", "3kg", "4kg", "5kg"],
    pricing: { "1kg": 505, "2kg": 1010, "3kg": 1515, "4kg": 2020, "5kg": 2525 },
    cutTypes: ["Whole", "Flat Cut", "Point Cut"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 49,
    name: "Brisket Roll",
    category: "Beef Meat",
    description: "Rolled beef brisket",
    image: "https://tse3.mm.bing.net/th/id/OIP.RBgxeS4S7psQ8zbQUMAX0QHaHa?cb=defcachec2&rs=1&pid=ImgDetMain&o=7&rm=3?w=500",
    images: ["https://tse3.mm.bing.net/th/id/OIP.RBgxeS4S7psQ8zbQUMAX0QHaHa?cb=defcachec2&rs=1&pid=ImgDetMain&o=7&rm=3?w=800"],
    fullDescription: "Rolled beef brisket - perfect for roasting.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      bestUse: "Roasting",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["per piece"],
    pricing: { "per piece": 1580 },
    cutTypes: ["Rolled"],
    packagingOptions: ["Vacuum Sealed"]
  },

  // ==================== ELITE BEEF STEAKS CATEGORY (11 products) ====================
  {
    id: 50,
    name: "Sirloin Tip Steak",
    category: "Elite Beef Steaks",
    description: "Lean sirloin tip steak",
    image: "https://www.farmhousemeatmarket.com/wp-content/uploads/2020/06/Sirloin-Tip-Steak-1470x1088.jpg?w=500",
    images: ["https://www.farmhousemeatmarket.com/wp-content/uploads/2020/06/Sirloin-Tip-Steak-1470x1088.jpg?w=800"],
    fullDescription: "Lean and flavorful sirloin tip steak.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      aging: "7-day aged",
      storage: "Keep refrigerated at 0-4°C",
      shelfLife: "3-5 days"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 275, "1kg": 555, "1.5kg": 825, "2kg": 1100 },
    cutTypes: ["Whole Steak"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 51,
    name: "Sirloin Center Steak",
    category: "Elite Beef Steaks",
    description: "Premium center-cut sirloin",
    image: "https://embed.widencdn.net/img/beef/13ribrlmsh/exact/Top%20Sirloin%20Steak_Center-Cut_Boneless_1184B.psd?keep=c&u=7fueml?w=500",
    images: ["https://embed.widencdn.net/img/beef/13ribrlmsh/exact/Top%20Sirloin%20Steak_Center-Cut_Boneless_1184B.psd?keep=c&u=7fueml?w=800"],
    fullDescription: "Center-cut sirloin steak with excellent marbling.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      aging: "14-day aged",
      grade: "Premium Choice",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 275, "1kg": 555, "1.5kg": 825, "2kg": 1100 },
    cutTypes: ["Center Cut"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 52,
    name: "Strip Loin Steak",
    category: "Elite Beef Steaks",
    description: "Premium striploin steak",
    image: "https://stirlingbutchery.com/wp-content/uploads/2020/04/Striploin-Pic.jpg?w=500",
    images: ["https://stirlingbutchery.com/wp-content/uploads/2020/04/Striploin-Pic.jpg?w=800"],
    fullDescription: "Premium striploin steak with excellent marbling.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      aging: "21-day aged",
      grade: "Premium Choice",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg"],
    pricing: { "500g": 290, "1kg": 580, "1.5kg": 870 },
    cutTypes: ["Whole Steak"],
    packagingOptions: ["Vacuum Sealed"]
  },
  {
    id: 53,
    name: "Strip Loin Steak Piece",
    category: "Elite Beef Steaks",
    description: "Individual striploin steak piece",
    image: "https://i.pinimg.com/1200x/23/fa/55/23fa5592cd39dc13fd0514be4bbaf749.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/23/fa/55/23fa5592cd39dc13fd0514be4bbaf749.jpg?w=800"],
    fullDescription: "Individual portion striploin steak piece.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      aging: "21-day aged",
      grade: "Premium Choice",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["Per Piece", "2 Pieces", "4 Pieces"],
    pricing: { "Per Piece": 140, "2 Pieces": 280, "4 Pieces": 560 },
    cutTypes: ["Individual Steak"],
    packagingOptions: ["Vacuum Sealed"]
  },
  {
    id: 54,
    name: "New York Steak",
    category: "Elite Beef Steaks",
    description: "Classic New York strip steak",
    image: "https://i.pinimg.com/1200x/8d/95/75/8d9575f6ae0ea8147a4735ce1ba60be9.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/8d/95/75/8d9575f6ae0ea8147a4735ce1ba60be9.jpg?w=800"],
    fullDescription: "Classic New York strip steak - tender and well-marbled.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      aging: "21-day aged",
      grade: "Premium Choice",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg"],
    pricing: { "500g": 290, "1kg": 580, "1.5kg": 870 },
    cutTypes: ["Whole Steak"],
    packagingOptions: ["Vacuum Sealed"]
  },
  {
    id: 55,
    name: "Fillet Steak",
    category: "Elite Beef Steaks",
    description: "Premium beef fillet steak",
    image: "https://th.bing.com/th/id/R.6e9ebdda9365a707f717decfd30e0318?rik=PxIyohX0iO6TaA&pid=ImgRaw&r=0?w=500",
    images: ["https://th.bing.com/th/id/R.6e9ebdda9365a707f717decfd30e0318?rik=PxIyohX0iO6TaA&pid=ImgRaw&r=0?w=800"],
    fullDescription: "The most tender cut - premium beef fillet steak.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      aging: "21-day aged",
      grade: "Premium Choice",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg"],
    pricing: { "500g": 390, "1kg": 780, "1.5kg": 1170 },
    cutTypes: ["Whole Steak"],
    packagingOptions: ["Vacuum Sealed"]
  },
  {
    id: 56,
    name: "Fillet Steak Piece",
    category: "Elite Beef Steaks",
    description: "Individual fillet steak piece",
    image: "https://www.johnmageebutchers.co.uk/wp-content/uploads/2021/08/Fillet-Steak.jpg?w=500",
    images: ["https://www.johnmageebutchers.co.uk/wp-content/uploads/2021/08/Fillet-Steak.jpg?w=800"],
    fullDescription: "Individual portion fillet steak - perfect for one.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      aging: "21-day aged",
      grade: "Premium Choice",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["Per Piece", "2 Pieces", "4 Pieces"],
    pricing: { "Per Piece": 125, "2 Pieces": 250, "4 Pieces": 500 },
    cutTypes: ["Individual Steak"],
    packagingOptions: ["Vacuum Sealed"]
  },
  {
    id: 57,
    name: "T-Bone Steak",
    category: "Elite Beef Steaks",
    description: "Classic T-bone steak",
    image: "https://i.pinimg.com/1200x/30/c5/d4/30c5d4b34caeecbdf7c519ecf63c1b05.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/30/c5/d4/30c5d4b34caeecbdf7c519ecf63c1b05.jpg?w=800"],
    fullDescription: "Classic T-bone steak - striploin and tenderloin in one cut.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      aging: "21-day aged",
      grade: "Premium Choice",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg"],
    pricing: { "500g": 295, "1kg": 590, "1.5kg": 885 },
    cutTypes: ["Bone-In"],
    packagingOptions: ["Vacuum Sealed"]
  },
  {
    id: 58,
    name: "Ribeye Steak",
    category: "Elite Beef Steaks",
    description: "Premium ribeye steak",
    image: "https://i.pinimg.com/736x/50/95/02/5095025a732331af8fedbaf32464afae.jpg?w=500",
    images: ["https://i.pinimg.com/736x/50/95/02/5095025a732331af8fedbaf32464afae.jpg?w=800"],
    fullDescription: "Premium ribeye steak with exceptional marbling.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      aging: "21-day aged",
      grade: "Premium Choice",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg"],
    pricing: { "500g": 295, "1kg": 590, "1.5kg": 885 },
    cutTypes: ["Boneless", "Bone-In"],
    packagingOptions: ["Vacuum Sealed"]
  },
  {
    id: 59,
    name: "Tomahawk Steak",
    category: "Elite Beef Steaks",
    description: "Impressive tomahawk ribeye",
    image: "https://i.pinimg.com/736x/ed/27/0a/ed270acd1a959e9a389bfdd251403d4f.jpg?w=500",
    images: ["https://i.pinimg.com/736x/ed/27/0a/ed270acd1a959e9a389bfdd251403d4f.jpg?w=800"],
    fullDescription: "Impressive tomahawk ribeye with long bone - a showstopper.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      aging: "28-day aged",
      grade: "Premium Choice",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["per piece"],
    pricing: { "per piece": 380 },
    cutTypes: ["With Long Bone"],
    packagingOptions: ["Vacuum Sealed"]
  },
  {
    id: 60,
    name: "Tri Tip Steak",
    category: "Elite Beef Steaks",
    description: "Lean and flavorful flank",
    image: "https://i.pinimg.com/1200x/03/4e/36/034e36500fbf90b26c5a7d550040248d.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/03/4e/36/034e36500fbf90b26c5a7d550040248d.jpg?w=800"],
    fullDescription: "Lean and flavorful Tri Tip steak - perfect for fajitas.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      bestUse: "Grilling, stir-fry",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 290, "1kg": 580, "1.5kg": 870, "2kg": 1160 },
    cutTypes: ["Whole", "Sliced"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },

  // ==================== LAMB MEAT CATEGORY (16 products) ====================
  {
    id: 61,
    name: "Lamb Sausages",
    nameAr: "سجق ضاني",
    category: "Lamb Meat",
    description: "Traditional lamb sausages",
    image: "https://saffronalley.com/cdn/shop/products/halal-lamb-sausages.jpg?v=1605561043?w=500",
    images: ["https://i.pinimg.com/1200x/e8/e1/16/e8e116aba095965438d4619d5f9fa1dc.jpg?w=800"],
    fullDescription: "Premium lamb sausages made with traditional spices.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Made fresh daily",
      casings: "Natural",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg", "2.5kg", "3kg"],
    pricing: { "500g": 335, "1kg": 670, "1.5kg": 1005, "2kg": 1340, "2.5kg": 1675, "3kg": 2010 },
    cutTypes: ["Links"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 62,
    name: "Lamb Meatballs",
    nameAr: "كفته داود باشا ضاني",
    category: "Lamb Meat",
    description: "Premium lamb meatballs - Dawood Basha style",
    image: "https://i.pinimg.com/1200x/63/e8/c8/63e8c8d51c81384f0edd76b7c8786225.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/63/e8/c8/63e8c8d51c81384f0edd76b7c8786225.jpg?w=800"],
    fullDescription: "Traditional Dawood Basha lamb meatballs.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Made fresh daily",
      style: "Dawood Basha",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 325, "1kg": 650, "1.5kg": 975, "2kg": 1300 },
    cutTypes: ["Meatballs"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 63,
    name: "Lamb Kofta",
    nameAr: "كفته ضاني",
    category: "Lamb Meat",
    description: "Traditional Egyptian lamb kofta",
    image: "https://i.pinimg.com/1200x/b8/cb/ee/b8cbee10326fd0bdaae834949bf6d770.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/b8/cb/ee/b8cbee10326fd0bdaae834949bf6d770.jpg?w=800"],
    fullDescription: "Premium lamb kofta with traditional Egyptian spices.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Made fresh daily",
      seasoning: "Traditional blend",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 330, "1kg": 660, "1.5kg": 990, "2kg": 1320 },
    cutTypes: ["Ground Kofta", "On Skewers"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 64,
    name: "Lamb Tarp Kofta",
    nameAr: "كفته طرب",
    category: "Lamb Meat",
    description: "Lamb kofta wrapped in lamb fat",
    image: "https://i.pinimg.com/1200x/1d/b5/bb/1db5bb03142b1d5c30d54ab268e2fbfb.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/1d/b5/bb/1db5bb03142b1d5c30d54ab268e2fbfb.jpg?w=800"],
    fullDescription: "Premium lamb kofta wrapped in lamb fat for extra flavor.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Made fresh daily",
      style: "Tarp (fat-wrapped)",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 340, "1kg": 680, "1.5kg": 1020, "2kg": 1360 },
    cutTypes: ["Fat-Wrapped"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 65,
    name: "Lamb Leg",
    nameAr: "فخدة ضاني",
    category: "Lamb Meat",
    description: "Whole lamb leg with bone",
    image: "https://i.pinimg.com/1200x/d8/74/01/d87401df036e65bbae7b866b3c8e0d91.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/d8/74/01/d87401df036e65bbae7b866b3c8e0d91.jpg?w=800"],
    fullDescription: "Premium whole lamb leg with bone for roasting.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      cut: "Bone-in",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["per piece"],
    pricing: { "per piece": 2450 },
    cutTypes: ["Bone-In"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 66,
    name: "Lamb Leg Boneless",
    nameAr: "فخدة ضاني مشفي",
    category: "Lamb Meat",
    description: "Boneless lamb leg",
    image: "https://simplymeats.co.nz/wp-content/uploads/2024/03/lamb-leg-boneless.jpg?w=500",
    images: ["https://simplymeats.co.nz/wp-content/uploads/2024/03/lamb-leg-boneless.jpg?w=800"],
    fullDescription: "Premium boneless lamb leg for easy roasting.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      cut: "Boneless",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["per piece"],
    pricing: { "per piece": 2350 },
    cutTypes: ["Boneless"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 67,
    name: "Lamb Leg Steak",
    nameAr: "ستيك فخدة ضاني",
    category: "Lamb Meat",
    description: "Premium lamb leg steaks",
    image: "https://tse4.mm.bing.net/th/id/OIP.dK1cT-7tecb6wUkqliu4EQHaHa?cb=defcachec2&rs=1&pid=ImgDetMain&o=7&rm=3?w=500",
    images: ["https://tse4.mm.bing.net/th/id/OIP.dK1cT-7tecb6wUkqliu4EQHaHa?cb=defcachec2&rs=1&pid=ImgDetMain&o=7&rm=3?w=800"],
    fullDescription: "Premium lamb leg cut into steaks.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      cut: "Steak cut",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 360, "1kg": 720, "1.5kg": 1080, "2kg": 1440 },
    cutTypes: ["Steak Cut"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 68,
    name: "Lamb Shoulder Boneless",
    nameAr: "كتف مشفي ضاني",
    category: "Lamb Meat",
    description: "Boneless lamb shoulder",
    image: "https://i.pinimg.com/1200x/70/5a/e2/705ae22466d7953e6e25dfdb99b76531.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/70/5a/e2/705ae22466d7953e6e25dfdb99b76531.jpg?w=800"],
    fullDescription: "Premium boneless lamb shoulder for slow cooking.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      cut: "Boneless",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["per piece"],
    pricing: { "per piece": 1650  },
    cutTypes: ["Boneless"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 69,
    name: "Lamb Fats",
    nameAr: "ليه ضاني",
    category: "Lamb Meat",
    description: "Premium lamb fat for cooking",
    image: "https://th.bing.com/th/id/OIP.l2jpENFmze7FYAgeY3Ay9AHaJQ?o=7&cb=defcachec2rm=3&rs=1&pid=ImgDetMain&o=7&rm=3?w=500",
    images: ["https://th.bing.com/th/id/OIP.l2jpENFmze7FYAgeY3Ay9AHaJQ?o=7&cb=defcachec2rm=3&rs=1&pid=ImgDetMain&o=7&rm=3?w=800"],
    fullDescription: "Premium lamb fat (Liya) for traditional cooking.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      type: "Pure lamb fat",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 170, "1kg": 340, "1.5kg": 510, "2kg": 680 },
    cutTypes: ["Whole", "Diced"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 70,
    name: "Lamb Shoulder",
    nameAr: "كتف ضاني كامل بالعضم",
    category: "Lamb Meat",
    description: "Whole lamb shoulder with bone",
    image: "https://i.pinimg.com/1200x/f2/18/6c/f2186c30d01e77e70d1c5468c3885d82.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/f2/18/6c/f2186c30d01e77e70d1c5468c3885d82.jpg?w=800"],
    fullDescription: "Whole lamb shoulder with bone for slow roasting.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      cut: "Bone-in, whole",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["per piece"],
    pricing: { "per piece": 1750 },
    cutTypes: ["Bone-In"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 71,
    name: "Ground Lamb",
    nameAr: "مفروم ضاني",
    category: "Lamb Meat",
    description: "Premium ground lamb meat",
    image: "https://i.pinimg.com/1200x/ad/3f/b2/ad3fb29a7b56d1f9938019b8f1927811.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/ad/3f/b2/ad3fb29a7b56d1f9938019b8f1927811.jpg?w=800"],
    fullDescription: "Freshly ground lamb meat for kofta and more.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Ground fresh daily",
      fatContent: "Medium",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 325, "1kg": 650, "1.5kg": 975, "2kg": 1300 },
    cutTypes: ["Ground"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 72,
    name: "Lamb Neck",
    nameAr: "رقبه ضاني",
    category: "Lamb Meat",
    description: "Lamb neck for slow cooking",
    image: "https://www.chalmarbeef.co.za/wp-content/uploads/2022/01/Lamb-Neck-styled-min.jpg?w=500",
    images: ["https://www.chalmarbeef.co.za/wp-content/uploads/2022/01/Lamb-Neck-styled-min.jpg?w=800"],
    fullDescription: "Lamb neck for slow-cooked stews.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      bestUse: "Slow cooking, stewing",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 320, "1kg": 640, "1.5kg": 960, "2kg": 1280 },
    cutTypes: ["Whole", "Sliced"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 73,
    name: "Lamb Shank",
    nameAr: "موزه ضاني",
    category: "Lamb Meat",
    description: "Premium lamb shank",
    image: "https://i.pinimg.com/736x/04/bb/1a/04bb1af7b6a0ae83efab62e6b30ce4b3.jpg?w=500",
    images: ["https://i.pinimg.com/736x/04/bb/1a/04bb1af7b6a0ae83efab62e6b30ce4b3.jpg?w=800"],
    fullDescription: "Premium lamb shank for braising.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      bestUse: "Braising, stewing",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["Per Piece", "2 Pieces", "4 Pieces"],
    pricing: { "Per Piece": 345, "2 Pieces": 620, "4 Pieces": 1200 },
    cutTypes: ["Bone-In"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 74,
    name: "Lamb T-Bone",
    nameAr: "بيت كلاوي",
    category: "Lamb Meat",
    description: "Premium lamb T-bone steaks",
    image: "https://shop.fatbutcher.co.za/cdn/shop/products/Web-Bits-13_850x.jpg?v=1640190791?w=500",
    images: ["https://shop.fatbutcher.co.za/cdn/shop/products/Web-Bits-13_850x.jpg?v=1640190791?w=800"],
    fullDescription: "Premium lamb T-bone steaks (Beit Kilawi).",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      cut: "T-bone",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 340, "1kg": 680, "1.5kg": 1020, "2kg": 1360 },
    cutTypes: ["T-Bone Cut"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 75,
    name: "Lamb Cubes",
    nameAr: "كباب حله ضاني",
    category: "Lamb Meat",
    description: "Premium lamb cubes for stewing",
    image: "https://i.pinimg.com/1200x/62/f7/36/62f736b27b0fcb306115ac4bd5c39454.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/62/f7/36/62f736b27b0fcb306115ac4bd5c39454.jpg?w=800"],
    fullDescription: "Premium lamb cubes for traditional stews.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      cut: "Cubed",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 400, "1kg": 800, "1.5kg": 1200, "2kg": 1600 },
    cutTypes: ["Cubed"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },
  {
    id: 76,
    name: "Lamb Chops",
    nameAr: "ريش ضاني",
    category: "Lamb Meat",
    description: "Premium lamb chops",
    image: "https://i.pinimg.com/736x/ce/16/da/ce16da92c3759bde60eb7b0e31536c21.jpg?w=500",
    images: ["https://i.pinimg.com/736x/ce/16/da/ce16da92c3759bde60eb7b0e31536c21.jpg?w=800"],
    fullDescription: "Premium lamb chops for grilling.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Fresh daily",
      cut: "Chop/Rack",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 360, "1kg": 720, "1.5kg": 1080, "2kg": 1440 },
    cutTypes: ["Single Chops", "French Rack"],
    packagingOptions: ["Vacuum Sealed", "Fresh Pack"]
  },

  // ==================== HOMEMADE PRODUCTS CATEGORY (6 products) ====================
  {
    id: 77,
    name: "Vine Leaves",
    category: "Homemade Products",
    description: "Stuffed vine leaves",
    image: "https://i.pinimg.com/736x/7a/41/bc/7a41bcd40cde60b85e0339111df92e3a.jpg?w=500",
    images: ["https://i.pinimg.com/736x/7a/41/bc/7a41bcd40cde60b85e0339111df92e3a.jpg?w=800"],
    fullDescription: "Traditional stuffed vine leaves with meat and rice.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Made fresh daily",
      filling: "Meat and rice",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["Dish 500g", "Dish 1kg"],
    pricing: { "Dish 500g": 130, "Dish 1kg": 260},
    cutTypes: ["Ready to Cook"],
    packagingOptions: ["Fresh Pack"]
  },
  {
    id: 78,
    name: "Mombar",
    category: "Homemade Products",
    description: "Traditional Egyptian mombar",
    image: "https://i.pinimg.com/736x/d4/f4/d3/d4f4d3a844c51024cfa41f8e97833233.jpg?w=500",
    images: ["https://i.pinimg.com/736x/d4/f4/d3/d4f4d3a844c51024cfa41f8e97833233.jpg?w=800"],
    fullDescription: "Traditional Egyptian mombar - stuffed intestines with rice and meat.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Made fresh daily",
      filling: "Rice and meat",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["Dish 500g", "Dish 1kg"],
    pricing: { "Dish 500g": 175, "Dish 1kg": 350},
    cutTypes: ["Ready to Cook"],
    packagingOptions: ["Fresh Pack"]
  },
  {
    id: 79,
    name: "Minced Meat Kobeba",
    category: "Homemade Products",
    description: "Traditional kobeba with minced meat",
    image: "https://i.pinimg.com/1200x/7b/c0/ba/7bc0ba70abc5086c04553e09668c16c9.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/7b/c0/ba/7bc0ba70abc5086c04553e09668c16c9.jpg?w=800"],
    fullDescription: "Traditional kobeba filled with seasoned minced meat.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Made fresh daily",
      filling: "Minced meat",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["10 pieces"],
    pricing: { "10 pieces": 130 },
    cutTypes: ["Ready to Fry"],
    packagingOptions: ["Fresh Pack", "Freezer Pack"]
  },
  {
    id: 80,
    name: "Meat Sambusak",
    category: "Homemade Products",
    description: "Traditional meat sambusak",
    image: "https://i.pinimg.com/1200x/a7/32/25/a73225527ed49fde0c79ea0ce407be63.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/a7/32/25/a73225527ed49fde0c79ea0ce407be63.jpg?w=800"],
    fullDescription: "Traditional sambusak filled with seasoned meat.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Made fresh daily",
      filling: "Seasoned meat",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["Dish 500g"],
    pricing: { "Dish 500g": 250 },
    cutTypes: ["Ready to Fry"],
    packagingOptions: ["Fresh Pack", "Freezer Pack"]
  },
  {
    id: 81,
    name: "Mix Cheese Sambusak",
    category: "Homemade Products",
    description: "Sambusak with mixed cheese",
    image: "https://i.pinimg.com/736x/3b/5d/af/3b5daf764b48ef80711650cdce6c1665.jpg?w=500",
    images: ["https://i.pinimg.com/736x/3b/5d/af/3b5daf764b48ef80711650cdce6c1665.jpg?w=800"],
    fullDescription: "Sambusak filled with a blend of melting cheeses.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      freshness: "Made fresh daily",
      filling: "Mixed cheese",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["Dish 500g"],
    pricing: { "Dish 500g": 170, "12 Pieces": 220, "24 Pieces": 425 },
    cutTypes: ["Ready to Fry"],
    packagingOptions: ["Fresh Pack", "Freezer Pack"]
  },

  // ==================== SMOKED CATEGORY (6 products) ====================
  {
    id: 83,
    name: "Smoked Ribeye Piece",
    category: "Smoked",
    description: "Individual smoked ribeye piece",
    image: "https://i.pinimg.com/736x/72/6f/85/726f85e83f9c704d420729f71038fab1.jpg?w=500",
    images: ["https://i.pinimg.com/736x/72/6f/85/726f85e83f9c704d420729f71038fab1.jpg?w=800"],
    fullDescription: "Premium smoked ribeye piece with rich smoky flavor.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      preparation: "Cold smoked",
      flavor: "Rich smoky",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["Per Piece"],
    pricing: { "Per Piece": 230},
    cutTypes: ["Individual Piece"],
    packagingOptions: ["Vacuum Sealed"]
  },
  {
    id: 84,
    name: "Smoked Ribeye Whole",
    category: "Smoked",
    description: "Whole smoked ribeye",
    image: "https://i.pinimg.com/736x/93/b3/c1/93b3c17c949dd331d94aa4c7ad5b77a3.jpg?w=500",
    images: ["https://i.pinimg.com/736x/93/b3/c1/93b3c17c949dd331d94aa4c7ad5b77a3.jpg?w=800"],
    fullDescription: "Whole smoked ribeye - perfect for special occasions.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      preparation: "Cold smoked",
      flavor: "Rich smoky",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["per piece"],
    pricing: { "per piece": 670 },
    cutTypes: ["Whole"],
    packagingOptions: ["Vacuum Sealed"]
  },
  {
    id: 85,
    name: "Smoked Burger",
    category: "Smoked",
    description: "Smoked beef burger patties",
    image: "https://i.pinimg.com/1200x/6f/f6/56/6ff6561bce04221c89169b0d152aeb56.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/6f/f6/56/6ff6561bce04221c89169b0d152aeb56.jpg?w=800"],
    fullDescription: "Premium smoked beef burger patties.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      preparation: "Smoked",
      weight: "per kilo",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 275, "1kg": 550, "1.5kg": 725, "2kg": 1100 },
    cutTypes: ["Smoked Patty"],
    packagingOptions: ["Vacuum Sealed"]
  },
  {
    id: 86,
    name: "Smoked Sausages",
    category: "Smoked",
    description: "Premium smoked beef sausages",
    image: "https://i.pinimg.com/736x/02/2d/81/022d818e3785130e4a65eb749a8d6aad.jpg?w=500",
    images: ["https://i.pinimg.com/736x/02/2d/81/022d818e3785130e4a65eb749a8d6aad.jpg?w=800"],
    fullDescription: "Premium smoked beef sausages with rich flavor.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      preparation: "Smoked",
      casings: "Natural",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 275, "1kg": 550, "1.5kg": 725, "2kg": 1100},
    cutTypes: ["Links"],
    packagingOptions: ["Vacuum Sealed"]
  },
  {
    id: 87,
    name: "Smoked Short Ribs",
    category: "Smoked",
    description: "Smoked beef short ribs",
    image: "https://i.pinimg.com/1200x/25/8f/48/258f4876b743e2a17f5e052d50eb9ad2.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/25/8f/48/258f4876b743e2a17f5e052d50eb9ad2.jpg?w=800"],
    fullDescription: "Premium smoked beef short ribs - fall off the bone tender.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      preparation: "Slow smoked",
      flavor: "Rich BBQ smoke",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 450, "1kg": 900, "1.5kg": 1350, "2kg": 1400 },
    cutTypes: ["Bone-In"],
    packagingOptions: ["Vacuum Sealed"]
  },
  {
    id: 88,
    name: "Smoked Brisket",
    category: "Smoked",
    description: "Texas-style smoked brisket",
    image: "https://i.pinimg.com/1200x/b4/80/86/b480865d08a5572bdb833282acc6271e.jpg?w=500",
    images: ["https://i.pinimg.com/1200x/b4/80/86/b480865d08a5572bdb833282acc6271e.jpg?w=800"],
    fullDescription: "Texas-style smoked brisket with perfect bark.",
    specifications: {
      origin: "EliteMeat Farms, Egypt",
      preparation: "12-hour smoked",
      flavor: "Traditional BBQ",
      storage: "Keep refrigerated at 0-4°C"
    },
    weightOptions: ["500g", "1kg", "1.5kg", "2kg"],
    pricing: { "500g": 315, "1kg": 630, "1.5kg": 945, "2kg": 1260},
    cutTypes: ["Sliced", "Whole"],
    packagingOptions: ["Vacuum Sealed"]
  }
];

export const productCategories = [
  {
    id: 1,
    name: "Beef Meat",
    image: "https://i.pinimg.com/736x/58/67/c0/5867c07be9879cbed8ff74b98ea2bf40.jpg",
    description: "Premium quality beef cuts and roasts"
  },
  {
    id: 2,
    name: "Elite Beef Steaks",
    image: "https://images.unsplash.com/photo-1680538491591-7ce20c900f4f?w=800",
    description: "Premium aged steaks for grilling"
  },
  {
    id: 3,
    name: "Lamb Meat",
    image: "https://i.pinimg.com/1200x/8c/7e/71/8c7e71c1b2cabdc2e85ccc724d975943.jpg",
    description: "Premium lamb cuts and specialty items"
  },
  {
    id: 4,
    name: "Homemade Products",
    image: "https://i.pinimg.com/736x/a9/8c/2f/a98c2f598fbc0786085d0e0442d11343.jpg",
    description: "Traditional homemade dishes"
  },
  {
    id: 5,
    name: "Smoked",
    image: "https://i.pinimg.com/736x/76/d6/ee/76d6eea0c69f82894e0b98c275adf201.jpg",
    description: "Premium smoked meats"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Ahmed Hassan",
    role: "Restaurant Owner",
    content: "EliteMeat has been our trusted supplier for 3 years. Quality is consistently excellent.",
    rating: 4
  },
  {
    id: 2,
    name: "Sarah Mohamed",
    role: "Wholesale Distributor",
    content: "Reliable delivery, premium quality, and exceptional service. Highly recommended!",
    rating: 5
  },
  {
    id: 3,
    name: "Khaled Ali",
    role: "Retail Manager",
    content: "Our customers love the freshness and quality of EliteMeat products.",
    rating: 5
  },
  {
    id: 4,
    name: "Fatma Ibrahim",
    role: "Home Chef",
    content: "The meats from EliteMeat have transformed my cooking. Exceptional quality!",
    rating: 4
  },
  {
    id: 5,
    name: "Omar Youssef",
    role: "Catering Business Owner",
    content: "Perfect for large events. Consistent quality every time we order.",
    rating: 5
  }
];

export const farmingPractices = [
  {
    id: 1,
    title: "Natural Feed",
    description: "Our livestock is fed with natural, organic feed without hormones or antibiotics"
  },
  {
    id: 2,
    title: "Ethical Treatment",
    description: "We ensure humane treatment and proper living conditions for all animals"
  },
  {
    id: 3,
    title: "Health Monitoring",
    description: "Regular veterinary checks and health monitoring for optimal livestock wellness"
  },
  {
    id: 4,
    title: "Hygienic Processing",
    description: "State-of-the-art facilities maintaining the highest hygiene standards"
  }
];

export const keyStrengths = [
  {
    id: 1,
    icon: "leaf",
    title: "Farm Fresh",
    description: "Direct from our farms to your table, ensuring maximum freshness"
  },
  {
    id: 2,
    icon: "check-circle",
    title: "Premium Quality",
    description: "Only the finest cuts selected by our expert butchers"
  },
  {
    id: 3,
    icon: "truck",
    title: "Fast Delivery",
    description: "Same-day delivery across Egypt for ultimate convenience"
  },
  {
    id: 4,
    icon: "shield",
    title: "100% Halal",
    description: "All products are certified halal and ethically sourced"
  }
];

export const productReviews = {
  1: [
    { id: 1, author: "Mohamed S.", rating: 5, date: "2025-01-15", comment: "Excellent quality fillet cubes!" },
    { id: 2, author: "Sara A.", rating: 4, date: "2025-01-10", comment: "Very tender and fresh." }
  ],
  55: [
    { id: 1, author: "Karim R.", rating: 5, date: "2025-01-13", comment: "The fillet steak was perfect!" },
    { id: 2, author: "Nadia F.", rating: 5, date: "2025-01-11", comment: "Restaurant quality at home." }
  ],
  58: [
    { id: 1, author: "Youssef M.", rating: 5, date: "2025-01-15", comment: "Best ribeye in Egypt!" },
    { id: 2, author: "Mona A.", rating: 5, date: "2025-01-12", comment: "Perfect for grilling." }
  ]
};
